import { Config } from 'scenes/common/types';
import { ConfigActions } from './configTypes';

export type ReduxAction = {
  type: string;
  payload: Partial<Config>;
};

const initialState: Config = {
  underMaintenance: false,
  ccMaintenance: false,
  productsUnderMaintenance: [],
  effectiveEndDate: '',
};

const configReducer = (currentState = initialState, action: ReduxAction) => {
  switch (action.type) {
    case ConfigActions.UPDATE_CONFIG:
      return {
        ...currentState,
        ...action.payload,
      };
    case ConfigActions.RESET_CONFIG:
      return initialState;
    default:
      return currentState;
  }
};

export default configReducer;
